'use client';

function handleTriggerKeyDown(event, {
  interactiveItemsLength,
  firstInteractiveIndex,
  setCurrentIndex,
  currentItemRef,
  isOpen,
  setIsOpen
}) {
  var _a;
  if (interactiveItemsLength > 0) {
    if (event.key === "ArrowDown" || event.key === "ArrowRight") {
      event.preventDefault();
      setIsOpen(true);
      setCurrentIndex(firstInteractiveIndex);
      (_a = currentItemRef.current) == null ? void 0 : _a.focus();
    }
    if ((event.key === "ArrowUp" || event.key === "ArrowLeft") && isOpen) {
      event.preventDefault();
      setIsOpen(false);
    }
  }
}
export {
  handleTriggerKeyDown
};
